export default __webpack_public_path__ + "images/showAllCars.9f623247.svg";